// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"06dbfaa0","977":"9aa69423"}[chunkId] + ".chunk.js";
};